import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { EditorEligibilityRule } from './editor-eligibility-rule.model';


const jsonValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  try {
    JSON.parse(control.value);
  } catch (e) {
    return { invalidJson: { value: control.value } };
  }
  return null;
};


export class EditorEligibilityRuleIsRawOperator extends EditorEligibilityRule {
  className = 'IsRawOperator';
  operatorName = 'isRawOperator';

  raw: string;

  constructor(obj?: any) {
    super({
      id: obj?.id ?? null
    });
    this.raw = obj?.raw ?? null;
  }

  static getFromLegacySerializedValues(legacyEligibilityRules: any) {
    const { description, ...legacyEligibilityRulesWithoutDescription } = legacyEligibilityRules;
    return new this({
      raw: JSON.stringify(legacyEligibilityRulesWithoutDescription)
    });
  }

  static getFromSerializedValues(serializedValues: any) {
    return new this({
      raw: JSON.stringify(serializedValues.raw)
    });
  }

  static getEmptyControlConfig(): { [key: string]: any; } {
    return {
      raw: [{ value: null, disabled: true }, EditorEligibilityRuleIsRawOperator.getRawControlOptions()]
    };
  }

  static getRawControlOptions(): any {
    return {
      validators: [jsonValidator],
      updateOn: 'blur'
    };
  }

  createCopy(): EditorEligibilityRuleIsRawOperator {
    return new EditorEligibilityRuleIsRawOperator({
      id: this.id,
      raw: this.raw
    });
  }

  getControlsConfig(): { [key: string]: any; } {
    return {
      raw: [this.raw, EditorEligibilityRuleIsRawOperator.getRawControlOptions()]
    };
  }

  getSerializedValues(): any {
    return {
      raw: JSON.parse(this.raw)
    };
  }
}
